import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Loader2 } from 'lucide-react';
import { CATEGORIES, localToday } from './financeUtils';

const empty = () => ({ description: '', amount: '', date: localToday(), category: CATEGORIES.income[0], note: '' });

export const TransactionDialog = ({ open, onClose, onSave }) => {
  const [type, setType] = useState('income');
  const [f, setF] = useState(empty());
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) { setType('income'); setF(empty()); } }, [open]);

  const changeType = (t) => { setType(t); setF((p) => ({ ...p, category: CATEGORIES[t][0] })); };
  const submit = async (e) => {
    e.preventDefault();
    const amount = Number(f.amount);
    if (!Number.isFinite(amount) || amount <= 0) return;
    setSaving(true);
    try { await onSave({ ...f, amount, type, note: f.note || null }); } finally { setSaving(false); }
  };
  const inp = 'w-full px-3 py-2.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-200';
  const isIn = type === 'income';

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="w-[calc(100%-1.5rem)] max-w-md rounded-2xl" data-testid="finance-tx-dialog">
        <DialogHeader>
          <DialogTitle>Nova movimentação</DialogTitle>
          <DialogDescription>Registre uma entrada ou saída do seu dinheiro.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="grid grid-cols-2 bg-slate-100 p-1 rounded-xl">
            <button type="button" onClick={() => changeType('income')} className={`py-2 rounded-lg text-sm font-semibold ${isIn ? 'bg-white text-emerald-700 shadow-sm' : 'text-slate-500'}`} data-testid="finance-type-income">+ Entrada</button>
            <button type="button" onClick={() => changeType('expense')} className={`py-2 rounded-lg text-sm font-semibold ${!isIn ? 'bg-white text-red-600 shadow-sm' : 'text-slate-500'}`} data-testid="finance-type-expense">− Saída</button>
          </div>
          <label className="block text-xs font-semibold text-slate-600">Descrição
            <input required maxLength={60} value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} placeholder="Ex.: salário, mercado, conta de luz" className={`${inp} mt-1`} data-testid="finance-description" />
          </label>
          <div className="grid grid-cols-2 gap-2">
            <label className="block text-xs font-semibold text-slate-600">Valor (R$)
              <input required type="number" min="0.01" step="0.01" inputMode="decimal" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} placeholder="0,00" className={`${inp} mt-1`} data-testid="finance-amount" />
            </label>
            <label className="block text-xs font-semibold text-slate-600">Data
              <input required type="date" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} className={`${inp} mt-1`} data-testid="finance-date" />
            </label>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <label className="block text-xs font-semibold text-slate-600">Categoria
              <select value={f.category} onChange={(e) => setF({ ...f, category: e.target.value })} className={`${inp} mt-1 bg-white`} data-testid="finance-category">
                {CATEGORIES[type].map((c) => <option key={c}>{c}</option>)}
              </select>
            </label>
            <label className="block text-xs font-semibold text-slate-600">Observação (opcional)
              <input maxLength={80} value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} placeholder="Detalhes" className={`${inp} mt-1`} data-testid="finance-note" />
            </label>
          </div>
          <button type="submit" disabled={saving} className={`w-full py-3 rounded-xl text-white font-bold flex items-center justify-center ${isIn ? 'bg-emerald-700' : 'bg-red-600'}`} data-testid="finance-save-btn">
            {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            {isIn ? 'Salvar entrada' : 'Salvar saída'}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
